import { createAuth0 } from '@auth0/auth0-vue'
import { ManualFixes } from 'common'

export default createAuth0({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin + '/callback',
    audience: import.meta.env.VITE_AUTH0_AUDIENCE
  }
})

export const isDataPipelineOverrideAdminEmail = (email: string | undefined | null): boolean => {
  if (!email) {
    return false
  }
  return ['mdaw@hellodata.ai'].includes(email)
}
